window.addEventListener('load', () => {
  setTextPosition()

  const changeGridButtons = document.querySelectorAll('a.card-button__grid')
  changeGridButtons.forEach((changeGridButton) => {
    changeGridButton.addEventListener('click', setTextPosition)
  })
})

window.addEventListener('collection:load-more', () => {
  setTextPosition()
})

window.addEventListener('resize', setTextPosition)

function setTextPosition() {
  const textContentElements = document.querySelectorAll(
    '.grid__item.grid__item--featured .text-wrapper'
  )

  textContentElements.forEach((textElement) => {
    const parentElem = textElement.closest('.grid__item.grid__item--featured')
    const horizontalPositioning = parseInt(parentElem.dataset.textHorizontal)
    const verticalPositioning = parseInt(parentElem.dataset.textVertical)

    const textElementWidth = textElement.getBoundingClientRect().width

    if (horizontalPositioning >= 25 && horizontalPositioning <= 75) {
      textElement.style.left = `calc(${horizontalPositioning}% - ${
        textElementWidth / 2
      }px)`
    } else if (horizontalPositioning > 75) {
      textElement.style.left = `calc(${horizontalPositioning}% - ${textElementWidth}px)`
    }

    // Get the size here so that it's after X positioning (text can wrap)
    const textElementHeight = textElement.getBoundingClientRect().height

    if (verticalPositioning >= 25 && verticalPositioning <= 75) {
      textElement.style.top = `calc(${verticalPositioning}% - ${
        textElementHeight / 2
      }px)`
    } else if (verticalPositioning > 75) {
      textElement.style.top = `calc(${verticalPositioning}% - ${textElementHeight}px)`
    }

    textElement.classList.remove('visibility-hidden')
  })
}
